import { useMutation } from '@apollo/react-hooks';
import { CartIdContext } from '@jetshop/core/components/Cart/CartIdContext';
import { addToCartSuccess } from '@jetshop/core/components/Mutation/AddToCart/addToCartUtils';
import t from '@jetshop/intl';
import React, { useContext } from 'react';
import { useNotification } from '@jetshop/core/components/Notifications';
import { addToCart } from '../Cart/queries/addToCart.gql';
import ProductToastWrapper from '../ProductPage/AddToCart/ProductToast';
import Button from '../ui/Button';

/**
 *
 * @param {object} props
 * @param {import('@jetshop/core/hooks/ProductList').ProductListProduct} props.product
 */
export function AddToCart({ product }) {
  const { cartId, setCartId } = useContext(CartIdContext);
  const articleNumber = product.variant?.articleNumber || product.articleNumber;
  const price = {
    price: product.variant?.price || product.price,
    previousPrice: product.variant?.previousPrice || product.previousPrice
  };

  const [trigger] = useNotification();

  const [add] = useMutation(addToCart, {
    variables: {
      input: {
        cartId,
        articleNumber,
        quantity: 1
      }
    },
    onCompleted: data => {
      trigger(
        <ProductToastWrapper
          selectedVariation={product.variant}
          product={product}
          quantity={1}
          price={price}
        />,
        { type: 'add-to-cart' }
      );

      addToCartSuccess({ cartId, setCartId })({ data });
    }
  });

  return (
    <Button buy list onClick={() => add()}>
      {t('Add to cart')}
    </Button>
  );
}
